import BasicFilterSelect from "../../../../../../common/BasicFilterSelect";

export default function CustomFieldOptionFilterSelect({input, customFieldOptions, handleChange = () => {}, meta}) {
    const { value } = input;

    return(
        <BasicFilterSelect
            input={input}
            placeholder={'Select custom field option'}
            options={customFieldOptions}
            value={value || null}
            onChange={handleChange}
            meta={meta}
        />
    )
}